<template>
    <div class="first_icon_mian">
        <img :src="imgble ? props.icon_name : getImageUrl(props.icon_name, props.path)" alt="">
    </div>
</template>
<script setup lang="ts">
import { ref, defineProps } from 'vue'
// const icon_url = ref('@/assets/Homeimg/')
let imgble = ref<any>()
const getImageUrl = (url: any, path: any) => {
    console.log(`../../assets/Homeimg/${url}`);
    return new URL(`../../assets/Homeimg/${url}`, import.meta.url).href;
}
const props = defineProps({
    icon_name: {
        type: String,
    },
    path: {
        type: String,

    }
})
imgble.value = props.icon_name?.includes("https")
</script>
<style  lang="less" scoped>
.first_icon_mian {
    // width: 24px;
    // height: 25px;
    // margin-left: 29px;
    width: 100%;
    height: 100%;

    img {
        width: 100%;
        height: 100%;
    }
}
</style>